
import greenLightBg from './images/light-bg.png';
import blueLightBg from './images/blue-light-bg.png';
import yellowLightBg from './images/yellow-light-bg.png';
import greenTitleLineImg from './images/title-line.png';
import blueTitleLineImg from './images/blue-title-line.png';
import yellowTitleLineImg from './images/yellow-title-line.png';
import pothookImg from './images/pothook.png';
import bluePothookImg from './images/blue-pothook.png';
import yellowPothookImg from './images/yellow-pothook.png';
import upgradeLevel1Bg from './images/upgrade-level1-bg.png';
import upgradeLevel6Bg from './images/upgrade-level6-bg.png';
import upgradeLevel11Bg from './images/upgrade-level11-bg.png';

const THEMEDATA = {
  level1: {
    bg: 'linear-gradient(220deg,#14433A 0.54%,rgba(16,18,25,0.00) 35.3%)',
    lightBg: greenLightBg,
    titleArrowBg: greenTitleLineImg,
    panelTitleColor: 'linear-gradient(178deg, #FFF 39.58%, #7BFF86 98.6%)',
    carousel: {
      color: '#3DB960',
      vipColor: 'linear-gradient(178deg, #fff 39.58%, #7bff86 98.6%)',
      pointColor: '#144C2E',
      pointDeepColor: '#378F5F',
      paginationColor: '#00CF5D',
      paginationArrowFillColor: '#D7FFE9',
      paginationArrowFilter: 'drop-shadow(0 0 7px #39CB5A)',
      subTitleColor: '#3DB960',
      progressBarStyle: {
        borderTop: '1px solid #B2FFA8',
        background: 'linear-gradient(180deg,rgba(61,185,96,0.00) 30%,#3DB960 100%)'
      },
      arrowColor: '#D7FFE9',
      lightLineColor: '#30A54B',
      lineColor: ['#32D858', '#163E2A', '#122723'],
    },
    reward: {
      color: '#00CF5D',
      weekTitleColor: '#00CF5D',
      lineBg: pothookImg,
      lockColor: '#378F5F',
      headerStyle: {
        background: 'linear-gradient(180deg, #1C5234 0%, #1B232A 100%)',
        boxShadow: '0 1px 0 0 #2D8A54 inset'
      },
      title: 'linear-gradient(178deg, #FFF 39.58%, #7BFF86 98.6%)',
      rangeBg: 'linear-gradient(180deg,#181D29 35.71%,#1B3A2E 100%)'
    },
    privileges: {
      title: 'linear-gradient(178deg, #FFF 39.58%, #7BFF86 98.6%)',
      cardBg: 'linear-gradient(125deg, #191C25 39.26%, #18382B 96.52%)',
      color: '#00CF5D',
      upgradeColor: '#00CF5D',
      blurColor: '#18372B',
    },
    upgradeGuide: {
      title: 'linear-gradient(178deg, #FFF 39.58%, #7BFF86 98.6%)',
      cardBg: 'linear-gradient(125deg, #181D29 39.26%, #18382B 96.52%)',
    },
    gradeBenefitsDetails: {
      color: '#3DB960',
      title: 'linear-gradient(178deg, #FFF 39.58%, #7BFF86 98.6%)',
    },
  },
  level6: {
    bg: 'linear-gradient(220deg, #223862 0.54%, rgba(16, 18, 25, 0.00) 35.3%)',
    lightBg: blueLightBg,
    titleArrowBg: blueTitleLineImg,
    panelTitleColor: 'linear-gradient(178deg, #FFF 39.58%, #46C9FF 98.6%)',
    carousel: {
      color: '#0BF',
      vipColor: 'linear-gradient(178deg, #FFF 39.58%, #46C9FF 98.6%)',
      pointColor: '#4276A6',
      pointDeepColor: '#305271',
      paginationColor: '#0BF',
      paginationArrowFillColor: '#D2F3FF',
      paginationArrowFilter: 'drop-shadow(0 0 7px #43A5F5)',
      subTitleColor: '#0BF',
      progressBarStyle: {
        borderTop: '1px solid #8DB2DB',
        background: 'linear-gradient(180deg, #15263B 30%, #39BFF3 100%)'
      },
      arrowColor: '#D2F3FF',
      lightLineColor: '#3598E9',
      lineColor: ['#327AD8', '#16213E', '#121527'],
    },
    reward: {
      color: '#3BBAE9',
      weekTitleColor: '#0BF',
      lineBg: bluePothookImg,
      lockColor: '#4276A6',
      headerStyle: {
        background: 'linear-gradient(180deg, #254870 0%, #1C222D 100%)',
        boxShadow: '0 1px 0 0 #498ECA inset'
      },
      title: 'linear-gradient(178deg, #FFF 39.58%, #46C9FF 98.6%)',
      rangeBg: 'linear-gradient(180deg, #181D29 35.71%, #233B56 100%)'
    },
    privileges: {
      title: 'linear-gradient(178deg, #FFF 39.58%, #46C9FF 98.6%)',
      cardBg: 'linear-gradient(125deg, #191C25 39.26%, #1A2D49 96.52%)',
      color: '#3BBAE9',
      upgradeColor: '#00CF5D',
      blurColor: '#1D3556',
    },
    upgradeGuide: {
      title: 'linear-gradient(178deg, #FFF 39.58%, #46C9FF 98.6%)',
      cardBg: 'linear-gradient(125deg, #181D29 39.26%, #1A2D49 96.52%)',
    },
    gradeBenefitsDetails: {
      color: '#0BF',
      title: 'linear-gradient(178deg, #FFF 39.58%, #46C9FF 98.6%)',
    },
  },
  level11: {
    bg: 'linear-gradient(220deg, #7C5D1A 0.54%, rgba(16, 18, 25, 0.00) 35.3%)',
    lightBg: yellowLightBg,
    titleArrowBg: yellowTitleLineImg,
    panelTitleColor: 'linear-gradient(178deg, #FFF 39.58%, #FFCC32 98.6%)',
    carousel: {
      color: '#F4C032',
      vipColor: 'linear-gradient(178deg, #FFF 39.58%, #FFCC32 98.6%)',
      pointColor: '#9A8753',
      pointDeepColor: '#5A5033',
      paginationColor: '#F4C032',
      paginationArrowFillColor: '#FFFDE9',
      paginationArrowFilter: 'drop-shadow(0 0 7px #F5CC43)',
      subTitleColor: '#F4C032',
      progressBarStyle: {
        borderTop: '1px solid #DBD28D',
        background: 'linear-gradient(180deg, rgba(244, 192, 50, 0.00) 30%, #F4C032 100%)'
      },
      arrowColor: '#FFFDE9',
      lightLineColor: '#E5A51A',
      lineColor: ['#D8AC32', '#3E2D16', '#121527'],
    },
    reward: {
      color: '#F4C032',
      weekTitleColor: '#F4C032',
      lineBg: yellowPothookImg,
      lockColor: '#9A8753',
      headerStyle: {
        background: 'linear-gradient(180deg, #554118 0%, #20232A 100%)',
        boxShadow: '0 1px 0 0 #B2963C inset'
      },
      title: 'linear-gradient(178deg, #FFF 39.58%, #FFCC32 98.6%)',
      rangeBg: 'linear-gradient(180deg, #181D29 35.71%, #37301A 100%)'
    },
    privileges: {
      title: 'linear-gradient(178deg, #FFF 39.58%, #FFCC32 98.6%)',
      cardBg: 'linear-gradient(125deg, #191C25 39.26%, #56471D 96.52%)',
      color: '#F4C032',
      upgradeColor: '#00CF5D',
      blurColor: '#423616',
    },
    upgradeGuide: {
      title: 'linear-gradient(178deg, #FFF 39.58%, #FFCC32 98.6%)',
      cardBg: 'linear-gradient(125deg, #191C25 39.26%, #42371C 96.52%)',
    },
    gradeBenefitsDetails: {
      color: '#F4C032',
      title: 'linear-gradient(178deg, #FFF 39.58%, #FFCC32 98.6%)',
    },
  }
};

const CARD_THEMEDATA = {
  level1: {
    color: '#00CF5D',
    arrowColor: '#00CF5D',
    vipColor: 'linear-gradient(178deg, #fff 39.58%, #7bff86 98.6%)',
    progressBarStyle: {
      borderTop: '1px solid #B2FFA8',
      background: 'linear-gradient(180deg,rgba(61,185,96,0.00) 30%,#3DB960 100%)'
    },
    startStopColor: '#222936',
    endStopColor: '#1A5938'
  },
  level6: {
    color: '#0BF',
    arrowColor: '#0BF',
    vipColor: 'linear-gradient(178deg, #FFF 39.58%, #46C9FF 98.6%)',
    progressBarStyle: {
      borderTop: '1px solid #8DB2DB',
      background: 'linear-gradient(180deg, #15263B 30%, #39BFF3 100%)'
    },
    startStopColor: '#222936',
    endStopColor: '#1A5938'
  },
  level11: {
    color: '#F4C032',
    arrowColor: '#F4C032',
    vipColor: 'linear-gradient(178deg, #FFF 39.58%, #FFCC32 98.6%)',
    progressBarStyle: {
      borderTop: '1px solid #DBD28D',
      background: 'linear-gradient(180deg, rgba(244, 192, 50, 0.00) 30%, #F4C032 100%)'
    },
    startStopColor: '#222936',
    endStopColor: '#1A5938'
  }
};

const INTEGRAL_THEMEDATA = {
  level1: {
    bg: 'linear-gradient(327deg, #181D29 62.99%, #18382B 98.98%)',
    barColor: ['#00CF5D', '#00FF73'],
    trackColor: 'rgba(0, 0, 0, 0.5)',
    cardBg: 'linear-gradient(125deg, #1D2432 39.26%, #18382B 96.52%)'
  },
  level6: {
    bg: 'linear-gradient(327deg, #181D29 62.99%, #1A2D49 98.98%)',
    barColor: ['#0BF', '#00D9FF'],
    trackColor: 'rgba(0, 0, 0, 0.5)',
    cardBg: 'linear-gradient(125deg, #1D2432 39.26%, #1C3458 96.52%)'
  },
  level11: {
    bg: 'linear-gradient(327deg, #181D29 62.99%, #42371C 98.98%)',
    barColor: ['#FFC600', '#FFEA00'],
    trackColor: 'rgba(0, 0, 0, 0.5)',
    cardBg: 'linear-gradient(125deg, #1E2431 39.26%, #3C3520 96.52%)'
  }
};

const REWARD_THEMEDATA = {
  level1: {
    border: '2px solid rgba(51, 211, 99, 0.30)',
    background: 'linear-gradient(101deg, #1E4033 0%, #181D29 58.11%), #131720'
  },
  level6: {
    border: '2px solid rgba(75, 153, 255, 0.30)',
    background: 'linear-gradient(101deg, #19345B 0%, #181D29 58.11%), #131720'
  },
  level11: {
    border: '2px solid rgba(255, 233, 147, 0.30)',
    background: 'linear-gradient(101deg, #3C3520 0%, #181D29 58.11%), #131720'
  }
};

const UPGRADE_THEMEDATA = {
  level1: {
    color: '#3DB960',
    vipColor: 'linear-gradient(178deg, #fff 39.58%, #7bff86 98.6%)',
    border: '2px solid rgba(227, 255, 232, 0.12)',
    background: 'linear-gradient(180deg, rgba(4, 67, 36, 0.00) 64.12%, rgba(4, 67, 36, 0.20) 100%), #161A22',
    bg: upgradeLevel1Bg.src
  },
  level6: {
    color: '#0BF',
    vipColor: 'linear-gradient(178deg, #FFF 39.58%, #46C9FF 98.6%)',
    border: '2px solid rgba(227, 244, 255, 0.12)',
    background: 'linear-gradient(180deg, rgba(17, 68, 116, 0.00) 64.12%, rgba(17, 68, 116, 0.20) 100%), #161A22',
    bg: upgradeLevel6Bg.src
  },
  level11: {
    color: '#F4C032',
    vipColor: 'linear-gradient(178deg, #FFF 39.58%, #FFCC32 98.6%)',
    border: '2px solid rgba(255, 252, 227, 0.12)',
    background: 'linear-gradient(180deg, rgba(25, 28, 33, 0.10) 64.12%, rgba(255, 136, 0, 0.07) 100%), #191C21',
    bg: upgradeLevel11Bg.src
  }
};

export const getThemeData = (level: number) => {
  if (level < 6) {
    return THEMEDATA.level1;
  } else if (level < 11) {
    return THEMEDATA.level6;
  }
  return THEMEDATA.level11;
};

export const getVipCardThemeData = (level: number) => {
  if (level < 6) {
    return CARD_THEMEDATA.level1;
  } else if (level < 11) {
    return CARD_THEMEDATA.level6;
  }
  return CARD_THEMEDATA.level11;
};

export {
  THEMEDATA,
  CARD_THEMEDATA,
  INTEGRAL_THEMEDATA,
  REWARD_THEMEDATA,
  UPGRADE_THEMEDATA
};